import { TinType } from "@common/types/counterparty";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import { TIN_TYPE_LABELS } from "./tinType";
import styles from "./CounterpartyTinSection.module.scss";

const TIN_TYPE_ITEMS: Array<PickerItemData<TinType>> = [
    TinType.SSN,
    TinType.EIN,
].map((type) => ({ value: type, label: TIN_TYPE_LABELS[type] }));

interface TinTypePickerProps {
    value: TinType;
    disabled: boolean;
    onValueChange?: (tinType: TinType) => void;
}

export const TinTypePicker = ({
    value,
    disabled,
    onValueChange,
}: TinTypePickerProps) => (
    <Picker.Select
        items={TIN_TYPE_ITEMS}
        value={value}
        onValueChange={(type) => {
            if (type !== null && type !== value) {
                onValueChange?.(type);
            }
        }}
        disabled={disabled}
        trigger={
            <Picker.Button
                variant="primary"
                size="lg"
                className={styles.typePicker}
                aria-label={`Tax ID type: ${TIN_TYPE_LABELS[value]}`}
            />
        }
    />
);
